import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { BaseService } from "../baseService";
import { Proxy } from "../proxy/proxy.service";

import * as mod from "../../models/otrosAuxiliares";

/**
 * Servicio para gestionar la participación de los Otros Auxiliares (auxiliares que no sean Entrenadores ni Delegados)
 */
@Injectable()
export class OtrosAuxiliaresService extends BaseService {
    private readonly _NombreServicio: string = "cFutbolActas/";

    // #region Propiedades del servicio
    listaParticipacionOtrosAuxiliares: mod.ActasParticipacionOtrosAuxiliares[] =
        [];
    lpoa$ = new BehaviorSubject<mod.ActasParticipacionOtrosAuxiliares[]>([]);
    listaParticipacionOtrosAuxiliares$: Observable<
        mod.ActasParticipacionOtrosAuxiliares[]
    > = this.lpoa$.asObservable();
    // #endregion

    constructor(http: HttpClient, http2: Http) {
        super(http, http2);
    }

    /**
     *
     * @param urlBase Dirección base de la API a la que se va a conectar.
     * @param id Identificador del participante a eliminar.
     */
    Eliminar(urlBase: string, id: number): void {
        this.http
            .get(
                this.UrlBase(urlBase) +
                    "eliminarParticipanteOtroAuxiliar?id=" +
                    id.toString() +
                    "&eliminarParticipanteOtroAuxiliar=true"
            )
            .subscribe({
                next: (resultado: boolean) => {
                    if (resultado) {
                        // Filtrar la lista de participantes para eliminar el registro id
                        this.listaParticipacionOtrosAuxiliares =
                            this.listaParticipacionOtrosAuxiliares.filter(
                                (m) => m.id != id
                            );
                        this.lpoa$.next(this.listaParticipacionOtrosAuxiliares);
                    }
                },
                error: (error) => console.error(error),
            });
    }

    /**
     * Elimina la lista completa de participantes.
     */
    EliminarTodos(
        urlBase: string,
        idDesignacion: number,
        idEquipo: number
    ): void {
        this.http
            .get(
                this.UrlBase(urlBase) +
                    "eliminarTodosParticipantesOtroAuxiliar?idDesignacion=" +
                    idDesignacion.toString() +
                    "&idEquipo=" +
                    idEquipo.toString() +
                    "&eliminarTodosParticipantesOtroAuxiliar=true"
            )
            .subscribe({
                next: (resultado: boolean) => {
                    if (resultado) {
                        // Filtrar la lista de participantes para eliminar el registro id
                        this.listaParticipacionOtrosAuxiliares = [];
                        this.lpoa$.next(this.listaParticipacionOtrosAuxiliares);
                    }
                },
                error: (error) => console.error(error),
            });
    }

    /**
     *
     * @param urlBase Dirección base de la API a la que se va a conectar
     * @param datos Datos de la participación de otro auxiliar
     */
    Guardar(
        urlBase: string,
        datos: mod.ActasParticipacionOtrosAuxiliares
    ): void {
        this.http
            .post(
                this.UrlBase(urlBase) + "guardarParticipanteOtroAuxiliar",
                datos
            )
            .subscribe({
                next: (resultado: mod.ActasParticipacionOtrosAuxiliares) => {
                    if (resultado != null) {
                        // Se añade directamente el resultado a la lista de participantes, ya que no se pueden actualizar los datos debido al funcionamiento de la aplicación (guardar o eliminar)
                        this.listaParticipacionOtrosAuxiliares.push(resultado);
                        this.lpoa$.next(this.listaParticipacionOtrosAuxiliares);
                    }
                },
                error: (error) => console.error(error),
            });
    }

    /**
     * Obtiene la lista de participantes (otros auxiliares) para una designación y un equipo.
     * @param urlBase Dirección base de la API a la que se va a conectar
     * @param idDesignacion Identificador de la designación
     * @param idEquipo Identificador del equipo
     * @returns Lista de participantes de otros auxiliares guardados en el sistema.
     */
    Lista(
        urlBase: string,
        idDesignacion: number,
        idEquipo: number
    ): Observable<mod.ActasParticipacionOtrosAuxiliares[]> {
        return new Observable<mod.ActasParticipacionOtrosAuxiliares[]>(
            (observer) => {
                this.http
                    .get(
                        this.UrlBase(urlBase) +
                            "participantesOtrosAuxiliares?idDesignacion=" +
                            idDesignacion.toString() +
                            "&idEquipo=" +
                            idEquipo.toString() +
                            "&participantesOtrosAuxiliares=true"
                    )
                    .subscribe({
                        next: (
                            resultado: mod.ActasParticipacionOtrosAuxiliares[]
                        ) => {
                            this.listaParticipacionOtrosAuxiliares = resultado;
                            this.lpoa$.next(
                                this.listaParticipacionOtrosAuxiliares
                            );

                            observer.next(resultado);
                            observer.complete();
                        },
                        error: (error) => console.error(error),
                    });
            }
        );
    }

    /**
     * Devuelve el nombre completo de un participante auxiliar por su identificador.
     * @param id Identificador del participante auxiliar
     * @returns Nombre completo del participante auxiliar
     */
    nombreCompletoPorId(id: number): string {
        let participante = this.listaParticipacionOtrosAuxiliares.find(m => m.id == id);

        if (participante != null) {
            return "<b>" + participante.apellido1 + " " + participante.apellido2 + "</b>, " + participante.nombre;
        }

        return "";
    }

    /**
     * Devuelve los datos del alineado por su DNI.
     * @param identificador Identificador de la persona
     * @returns Datos del alineado auxiliar
     */
    ObtenerPorIdentificador(
        identificador: string
    ): mod.ActasParticipacionOtrosAuxiliares {
        return this.listaParticipacionOtrosAuxiliares.find(
            (m) =>
                m.identificador.trim().toUpperCase() ==
                identificador.trim().toUpperCase()
        );
    }

    /**
     * Devuelve el tipo de licencia de un participante auxiliar por su identificador.
     * @param id Identificador del participante auxiliar
     * @returns Tipo de licencia del participante auxiliar
     */
    tipoLicenciaPorId(id: number): string {
        let participante = this.listaParticipacionOtrosAuxiliares.find(m => m.id == id);

        if (participante != null) {
            return participante.tipoLicencia;
        }

        return "";
    }

    /**
     *
     * @param url URL Base de la API
     * @returns Cadena con la dirección url base completa (URL Base de configuración + nombre del controlador a utilizar)
     */
    private UrlBase(url: string): string {
        return this.DireccionBase(url) + this._NombreServicio;
    }
}

/**
 * Servicio para gestionar las amonestaciones de los otros auxiliares.
 */
@Injectable()
export class OtrosAuxiliaresAmonestacionService extends BaseService {
    private readonly _NombreServicio: string = "cFutbolActas/";

    // #region Propiedades del servicio
    private lista: mod.ActasOtrosAuxiliaresAmonestacion[] = [];
    l$: BehaviorSubject<mod.ActasOtrosAuxiliaresAmonestacion[]> =
        new BehaviorSubject<mod.ActasOtrosAuxiliaresAmonestacion[]>([]);
    lista$: Observable<mod.ActasOtrosAuxiliaresAmonestacion[]> =
        this.l$.asObservable();

    loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    // #endregion

    constructor(http: HttpClient, http2: Http) {
        super(http, http2);
    }

    /**
     * Elimina una amonestación de un participante auxiliar.
     * @param urlBase Dirección base de la API a la que se va a conectar
     * @param id Identificador de la amonestación
     */
    eliminarAmonestacion(urlBase: string, id: number): Observable<boolean> {
        this.loading$.next(true);

        return new Observable<boolean>(observer => {

          this.http.delete(this.UrlBase(urlBase) + "eliminarAmonestacionOtroAuxiliar?id=" + id.toString()).subscribe({
              next: (resultado: boolean) => {
                  console.log(resultado);
  
                  // Filtrar la lista de amonestaciones para eliminar el registro id
                  this.lista = this.lista.filter((m) => m.id != id);
                  this.l$.next(this.lista);

                  observer.next(resultado);
              },
              error: (error) => {
                  this.loading$.next(false);
                  console.error(error);
                  observer.error(error);
              },
              complete: () => {
                  this.loading$.next(false);
                  observer.complete();
              },
          });

        });
    }

    /**
     * Guarda una amonestación de un participante auxiliar.
     * @param urlBase Dirección base de la API a la que se va a conectar
     * @param datos Datos de la amonestación
     * @returns Devuelve el resultado de la operación
     */
    guardarAmonestacion(
        urlBase: string,
        datos: mod.ActasOtrosAuxiliaresAmonestacion
    ): Observable<mod.ActasOtrosAuxiliaresAmonestacion> {
        this.loading$.next(true);

        return new Observable<mod.ActasOtrosAuxiliaresAmonestacion>(observer => {
          this.http
              .post(
                  this.UrlBase(urlBase) + "guardarAmonestacionOtroAuxiliar",
                  datos
              )
              .subscribe({
                  next: (resultado: mod.ActasOtrosAuxiliaresAmonestacion) => {
                      console.log(resultado);
  
                      // Incluir el resultado en la lista de amonestaciones
                      this.lista.push(resultado);
                      this.l$.next(this.lista);

                      observer.next(resultado);
                  },
                  error: (error) => {
                      this.loading$.next(false);
                      console.error(error);
                      observer.error(error);
                  },
                  complete: () => {
                      this.loading$.next(false);
                      observer.complete();
                  },
              });
        });
    }

    /**
     * Obtiene la lista de amonestaciones de otros auxiliares para una designación y un equipo.
     * @param urlBase Dirección base de la API a la que se va a conectar
     * @param idDesignacion Identificador de la designación
     * @param idEquipo Identificador del equipo
     * @returns Lista de amonestaciones de otros auxiliares
     */
    listaPorDesignacionYEquipo(
        urlBase: string,
        idDesignacion: number,
        idEquipo: number
    ): Observable<mod.ActasOtrosAuxiliaresAmonestacion[]> {
        this.loading$.next(true);

        return new Observable<mod.ActasOtrosAuxiliaresAmonestacion[]>(
            (observer) => {
                this.http
                    .get(
                        this.UrlBase(urlBase) +
                            "listaAmonestacionesOtrosAuxiliares?idDesignacion=" +
                            idDesignacion.toString() +
                            "&idEquipo=" +
                            idEquipo.toString()
                    )
                    .subscribe({
                        next: (
                            resultado: mod.ActasOtrosAuxiliaresAmonestacion[]
                        ) => {
                            this.lista = resultado;
                            this.l$.next(this.lista);
                            observer.next(resultado);
                        },
                        error: (error) => {
                            this.loading$.next(false);
                            console.error(error);
                        },
                        complete: () => {
                            this.loading$.next(false);
                            observer.complete();
                        },
                    });
            }
        );
    }

    /**
     * Indica si el participante ya tiene una amonestación.
     * @param idJugador Identificador del participante
     * @param codigos Lista de códigos de amonestación
     */
    tieneAmonestacion(
        idJugador: number,
        codigos: Proxy.ListaPrCodigoAmonestacion
    ): boolean {
        let resultado: boolean = false;

        if (this.lista != null &&this.lista.length > 0) {
            this.lista.forEach(
                (valor: mod.ActasOtrosAuxiliaresAmonestacion) => {
                    if (
                        valor.idActaParticipacionOtrosAuxiliares == idJugador &&
                        codigos.EsAmonestacion(valor.amonestacion)
                    ) {
                        resultado = true;
                    }
                }
            );
        }

        return resultado;
    }

    /**
     *
     * @param url URL Base de la API
     * @returns Cadena con la dirección url base completa (URL Base de configuración + nombre del controlador a utilizar)
     */
    private UrlBase(url: string): string {
        return this.DireccionBase(url) + this._NombreServicio;
    }
}



// WEBPACK FOOTER //
// ./src/services/api/otrosauxiliares.service.ts